import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-page',
  templateUrl: './print-page.component.html',
  styleUrls: ['./print-page.component.less']
})
export class PrintPageComponent implements OnInit {

  public total : any = []

  constructor() { }

  ngOnInit() {

let count = 3

for (let index = 0; index < count; index++) {
 this.total.push({check:index})
}

  }

}
